import { Component, Input, Output, OnInit, EventEmitter, ViewEncapsulation } from '@angular/core';
import { PaymentTypeModel } from '../../../models/paymenType.model';

@Component({
  selector: 'app-card-payment',
  templateUrl: './card-payment.component.html',
  styleUrls: ['./card-payment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CardPaymentComponent implements OnInit {
  @Output() paymentTypeSelected = new EventEmitter<PaymentTypeModel>();
  @Output() onCardSelect = new EventEmitter<{merchantId:string}>();

  constructor() { }

  ngOnInit(): void {
  }

  onCardSelection(selectedCardId:{merchantId:string}, paymentType:PaymentTypeModel){
    this.onCardSelect.emit(selectedCardId);
    this.paymentTypeSelected.emit(paymentType);
  }

  onPaymentTypeSelect(paymentType:PaymentTypeModel){
    this.paymentTypeSelected.emit(paymentType);
  }

}
